import axios from "axios";
import React, { useState, FormEvent } from "react";
import { Link, Navigate } from "react-router-dom";
import useAuth from "./auth/useAuth";

//import classNames from "classnames";

//import { News } from "./types";
import QRCode from 'qrcode.react';

interface HomeProps { }

const Home: React.FC<HomeProps> = () => {
  //const [news, setNews] = useState<News[]>();
  //const [isModalOpen, setModalState] = React.useState(false);
  const [isOpenGlobalForm, setIsOpenGlobalForm] = React.useState(false);
  const [isOpenNewsDialog, setSsOpenNewsDialog] = React.useState(true);

  // useEffect(() => {
  //   getNews();

  // }, [])

  // const toggleModal = () => {
  //   //getNews();
  //   setModalState(!isModalOpen);
  // };

  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState<any>({});

  const auth = useAuth();
  if (auth!.isAuthenticated()) return <Navigate to="/dashboard" />;

  const handleLogin = (event: FormEvent) => {
    event.preventDefault();

    auth?.signIn(async () => {
      try {
        const { data } = await axios.post("auth/sign-in", {
          login,
          password,
        });

        if (data.status === 400) {
          setErrors(data.message);
        } else {
          return data.cookie;
        }
      } catch (err: any) {
        setErrors(err.response.data);
      }
    });
  };


  // const getNews = async () => {
  //   try {
  //     await axios.get("/news").then((res) => setNews(res.data));
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  return (
    <div className="app">
      <div
        data-v-62385291
        className="auth "
        style={{ flexDirection: "column" }}
      >
        {isOpenNewsDialog ?
          <div
            data-v-62385291
            className="divDiv el-card container auth__card is-always-shadow"
          //style={{ minWidth: "30%", marginBottom: 20, paddingBottom: "20px"}}
          >

            <div className="el-card__body">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="flex align-center" style={{ textAlign: "center" }}>
                  <p style={{ fontSize: 20, fontWeight: 300 }}>Новости</p>
                </div>

                {/* <div className="flex">
                  <i
                    // className="icofont-plus-circle"
                    className={classNames(
                      isModalOpen
                        ? "icofont-minus-circle infIconRed"
                        : "icofont-plus-circle infIconGreen"
                    )}
                    onClick={toggleModal}
                  ></i>
                </div> */}
              </div>
              
              <>
                  <p
                    style={{
                      fontSize: 20,
                      fontWeight: 300,
                      textAlign: "center",
                      padding: 10,
                    }}
                  >
                    <p style={{
                      fontSize: 20,
                      fontWeight: 300,
                      textAlign: "center",
                      padding: 10,
                    }}>
                      Уважаемые абоненты. <br />
                        с 1-го мая 2026 года стоимость ВСЕХ тарифов возрастает на 5%.
			За исключением тарифов ФЛЕКС и ФЛЕКС-2.
			<br />
			В связи с увеличением скорости в обратном канале 100 и 200 Мбит/с,
			абонентская плата ФЛЕКС и ФЛЕКС-2 увеличивается на 15%.
                        <br />
			Стоимость турбо кнопки и дополнительного трафика остается без изменений.
                        Просим Вас учитывать это при оплате услуг за май месяц.
                      </p>
                  </p>
                  <div style={{ marginTop: "10px" }}>
                    <button
                      data-v-62385291=""
                      type="submit"
                      className="el-button el-button--primary"
                      style={{ width: "100%" }}
                      onClick={() => { setIsOpenGlobalForm(true); setSsOpenNewsDialog(false); }}
                    >
                      <span>
                        <small data-v-62385291="">Перейти в личный кабинет</small>
                      </span>
                    </button>
                  </div>
                </>

              {/* {news?.map((item) => (
                <>
                  <p
                    style={{
                      fontSize: 20,
                      fontWeight: 300,
                      textAlign: "center",
                      padding: 10,
                    }}
                  >
                    {item.title}
                  </p>
                  <p
                    dangerouslySetInnerHTML={{ __html: item.description }}
                    style={{
                      fontSize: 15,
                      color: "#2C2B2B",
                      textAlign: "justify",
                    }}
                  ></p>
                  <div style={{ marginTop: "10px" }}>
                    <button
                      data-v-62385291=""
                      type="submit"
                      className="el-button el-button--primary"
                      style={{ width: "100%" }}
                      onClick={() => { setIsOpenGlobalForm(true); setSsOpenNewsDialog(false); }}
                    >
                      <span>
                        <small data-v-62385291="">Перейти в личный кабинет</small>
                      </span>
                    </button>
                  </div>
                </>

              ))} */}
              {/* {isModalOpen ? (
            <>
              
            </>
          ) : null} */}
            </div>
          </div>
          : null}
        {isOpenGlobalForm ?
          <div
            data-v-62385291
            className="el-card container auth__card is-always-shadow"
            // className={classNames(
            //   isModalOpen
            //     ? "displayNone"
            //     : "el-card container auth__card is-always-shadow"
            // )}
          >
            <div className="el-card__body">
              <div data-v-62385291 className="flex flex-column align-center p-3">
                <img
                  data-v-62385291=""
                  alt="LANSAT"
                  src="data:image/png;base64,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"
                ></img>
                <h2 data-v-62385291="" className="auth__card-title">
                  Личный кабинет
                </h2>
              </div>

              <form
                data-v-62385291=""
                className="el-form auth__form is-disabled"
                onSubmit={handleLogin}
              >
                <div data-v-62385291="" className="el-form-item">
                  <div className="el-form-item__content">
                    <div data-v-62385291="" className="el-input">
                      <input
                        type="text"
                        autoComplete="off"
                        placeholder="Логин"
                        className="el-input__inner"
                        value={login}
                        onChange={(e) => setLogin(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div
                  data-v-62385291=""
                  className="el-form-item is-success is-required"
                >
                  <div className="el-form-item__content">
                    <div data-v-62385291="" className="el-input el-input--suffix">
                      <input
                        type="password"
                        autoComplete="off"
                        placeholder="Пароль"
                        className="el-input__inner"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <span className="el-input__suffix">
                        <span className="el-input__suffix-inner">
                          <i className="el-input__icon el-icon-view el-input__clear"></i>
                        </span>
                        <i className="el-input__icon el-input__validateIcon el-icon-circle-check"></i>
                      </span>
                    </div>

                    <div className="el-form-item__error el-form-item__error--inline2">
                      {errors.message === "User or password is incorrect" &&
                        "Логин или пароль неверны"}
                      {errors.message === "Incorrect Field Name(s)/ Value(s)" &&
                        "Неверное имя (я) поля (я) / значение (я)"}
                    </div>
                  </div>
                </div>

                <div
                  data-v-62385291=""
                  className="flex align-center justify-center wrap"
                  style={{ paddingBottom: 4 }}
                >
                  <button
                    data-v-62385291=""
                    type="submit"
                    className="el-button el-button--success"
                    style={{ width: "100%" }}
                  >
                    <span>
                      <small data-v-62385291="">Войти</small>
                    </span>
                  </button>
                </div>
              </form>
              <div>
                <div
                  data-v-62385291=""
                  className="flex align-center justify-center wrap"
                  style={{ paddingBottom: 4 }}
                >
                  <Link to="/login-phone" style={{ width: "100%" }}>
                    <button
                      data-v-62385291=""
                      type="submit"
                      className="el-button el-button--success"
                      style={{ width: "100%" }}
                    >
                      <span>
                        <small data-v-62385291="">Войти по номеру телефона</small>
                      </span>
                    </button>
                  </Link>
                </div>
                <div
                  data-v-62385291=""
                  className="flex align-center justify-center wrap"
                  style={{ paddingBottom: 20 }}
                >
                  <Link to="/recovery" style={{ width: "100%" }}>
                    <button
                      data-v-62385291=""
                      type="submit"
                      className="el-button el-button--primary"
                      style={{ width: "100%" }}
                    >
                      <span>
                        <small data-v-62385291="">Восстановить пароль</small>
                      </span>
                    </button>
                  </Link>
                </div>

              </div>
              <div data-v-62385291=""
                className="flex align-center justify-center wrap"
                style={{ flexDirection: "row", textAlign: "center", justifyContent: "space-between" }}
              >
                <span style={{ textAlign: "center", fontSize: "18px", paddingBottom: "20px" }}>Сканируй QR-код, получи мобильное приложение</span>
                <div>
                  <h2>Iphone</h2>
                  <QRCode value="https://apps.apple.com/ru/app/lansat-ru/id1567342215" />
                </div>
                <div >
                  <h2>Android</h2>
                  <QRCode value="https://play.google.com/store/apps/details?id=com.lansat.mobileoffice&hl=ru&gl=US" />
                </div>
                {/* <img src={Qr} alt="" width="150px" height="150px" /> */}

              </div>
            </div>
          </div>
          : null}

      </div>
    </div>
  );
};

export default Home;
